// frontend/src/SetAvailability.js
import React, { useState } from "react";
import "./App.css"; // Reuse global styles

const BACKEND_URL = process.env.REACT_APP_API_URL;
const PASSWORD = "changeme"; // Hardcoded password

function SetAvailability() {
  const [step, setStep] = useState("auth"); // "auth" or "main"
  const [password, setPassword] = useState("");
  const [availability, setAvailability] = useState({
    0: [], 1: [], 2: [], 3: [], 4: [], 5: [], 6: []
  }); // Hashmap for storing time slots
  const [start_date, setStartDate] = useState("");
  const [end_date, setEndDate] = useState("");
  const [clear_type, setClearType] = useState("none"); // "whole", "timeframe", or "none"

  // Handle password check
  const handleAuth = (e) => {
    e.preventDefault();
    if (password === PASSWORD) {
      setStep("main");
    } else {
      alert("Incorrect password.");
    }
  };

  // Handle adding a new time slot
  const handleAddTimeSlot = (day) => {
    const timeFormat = /^([01]\d|2[0-3]):([0-5]\d)$/; // Regex for HH:MM format
    const startTime = prompt("Enter start time (24hr) (HH:MM):");
    const endTime = prompt("Enter end time (24hr) (HH:MM):");
    
    if (startTime && endTime) {
      if (timeFormat.test(startTime) && timeFormat.test(endTime)) {
        setAvailability((prev) => ({
          ...prev,
          [day]: [...prev[day], { start: startTime, end: endTime }]
        }));
      } else {
        alert("Please enter times in the correct format (HH:MM).");
      }
    }
  };

  // Handle deleting a time slot
  const handleDeleteTimeSlot = (day, index) => {
    setAvailability((prev) => ({
      ...prev,
      [day]: prev[day].filter((_, i) => i !== index)
    }));
  };

  // Add a dropdown for clear_type selection
  const handleClearTypeChange = (e) => {
    setClearType(e.target.value);
  };

  // Handle submitting the availability
  const handleSubmit = async () => {
    if (!start_date || !end_date) {
      alert("Please enter both start date and end date in YYYY-MM-DD format.");
      return;
    }

    try {
      const response = await fetch(`${BACKEND_URL}/set-availability`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          availability: availability,
          start_date: start_date,
          end_date: end_date,
          clear_type: clear_type // Include clear_type in the payload
        }),
      });

      if (!response.ok) {
        throw new Error("Failed to submit availability");
      }

      alert("Availability submitted successfully!");
    } catch (error) {
      alert(`Error: ${error.message}`);
    }
  };

  // Auth step
  if (step === "auth") {
    return (
      <div className="app-container" style={{ minHeight: "100vh", justifyContent: "center" }}>
        <div className="step-content" style={{ maxWidth: 400, margin: "auto", marginTop: "10vh" }}>
          <h2 className="scheduler-title" style={{ textAlign: "center" }}>Admin Login</h2>
          <form onSubmit={handleAuth}>
            <div className="input-row">
              <label htmlFor="password">Enter password:</label>
              <input
                id="password"
                type="password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                autoFocus
              />
            </div>
            <button className="next-button" type="submit" style={{ width: "100%" }}>
              Login
            </button>
          </form>
        </div>
      </div>
    );
  }

  // Main step
  return (
    <div className="app-container" style={{ minHeight: "100vh", justifyContent: "center" }}>
      <div className="step-content" style={{ maxWidth: 800, margin: "auto", marginTop: "10vh" }}>
        <h2 className="scheduler-title" style={{ textAlign: "center" }}>
          Set Availability
        </h2>
        <div className="availability-grid" style={{ display: "flex", justifyContent: "space-between" }}>
          {["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"].map((day, index) => (
            <div key={index} className="day-column" style={{ flex: 1, margin: "0 5px" }}>
              <h3 style={{ textAlign: "center" }}>{day}</h3>
              <button
                className="add-time-slot-button"
                onClick={() => handleAddTimeSlot(index)}
                style={{ width: "100%", marginBottom: "10px" }}
              >
                Add Time Slot
              </button>
              <ul>
                {availability[index].map((slot, i) => (
                  <li key={i} style={{ position: "relative" }}>
                    {slot.start} - {slot.end}
                    <button
                      className="delete-time-slot-button"
                      onClick={() => handleDeleteTimeSlot(index, i)}
                      style={{
                        position: "absolute",
                        right: 0,
                        top: 0,
                        backgroundColor: "red",
                        color: "white",
                        border: "none",
                        cursor: "pointer"
                      }}
                    >
                      Delete
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="date-inputs" style={{ marginTop: "20px" }}>
          <div className="input-row">
            <label htmlFor="start-date">Start Date:</label>
            <input
              id="start-date"
              type="date"
              value={start_date}
              onChange={e => setStartDate(e.target.value)}
            />
          </div>
          <div className="input-row">
            <label htmlFor="end-date">End Date:</label>
            <input
              id="end-date"
              type="date"
              value={end_date}
              onChange={e => setEndDate(e.target.value)}
            />
          </div>
          <div className="input-row">
            <label htmlFor="clear-type">How to Clear Current Timeslots (won't clear booked slots):</label>
            <select
              id="clear-type"
              value={clear_type}
              onChange={handleClearTypeChange}
              style={{ width: "100%" }}
            >
              <option value="none">None - Don't clear any slots</option>
              <option value="whole">Whole - Clear all slots</option>
              <option value="timeframe">Timeframe - Clear slots only in the specified timeframe above</option>
            </select>
          </div>
        </div>
        <button
          className="submit-button"
          onClick={handleSubmit}
          style={{ width: "100%", marginTop: "20px" }}
        >
          Submit Availability
        </button>
      </div>
    </div>
  );
}

export default SetAvailability;